import React from 'react';
import { Container, Row, Col} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faFacebookSquare, faInstagramSquare, faLinkedin } from '@fortawesome/free-brands-svg-icons';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/App.css';


const HorizontalSpacer = () => {
    return <span className="h-spacer" />;
}


const IconBlock = (props) => {
    return (
        <div style={{display: 'inline'}}>
            <a href={props.href} target="_blank" rel='noopener noreferrer'>
                <FontAwesomeIcon icon={props.icon} size='2x' className='mb-3' style={{color: "var(--logo_1)", verticalAlign: "-50%"}} />
            </a>
        </div>
    );
}


const Contacts = () => {
    return (
        <section id="contact" className='elem-content-container'>
            <Container>
                <Row className='mb-5'>
                    <Col lg='8' className="mx-auto text-center">
                        <h2 className="section-heading text-primary">Contatti</h2>
                        <p className="mt-5 text-spec-claim">
                        Pensi possa aiutarti con il tuo problema? Non esitare a contattarmi!
                        </p>
                        <p className="d-none d-lg-block mt-2 text-spec-claim" style={{fontSize: '12px', fontStyle: 'normal'}}>
                        (Clicca i simboli per scegliere come contattarmi)
                        </p>
                        <p className="d-lg-none mt-2 text-spec-claim" style={{fontSize: '12px', fontStyle: 'normal'}}>
                        (Tocca i simboli per scegliere come contattarmi)
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col lg='4' className="text-left mb-5">
                        <ul className="list-unstyled">
                            <li className="text-contact">
                                <IconBlock href="https://wa.me/393884323535" icon={faWhatsapp} />
                                <HorizontalSpacer />
                                <div className="d-md-none" style={{display: 'inline-block'}}>
                                    <IconBlock href="tel:+39-388-432-3535" icon={faPhone} />
                                    <HorizontalSpacer />
                                </div>
                                +39 388 432 3535
                            </li>
                            <li className="text-contact">
                                <IconBlock href="mailto:verbanafisio@gmail.com" icon={faEnvelope} />
                                <HorizontalSpacer />
                                verbanafisio@gmail.com
                            </li>
                            <li className="text-contact">
                                <IconBlock href="https://www.facebook.com/drgianmarcoverbana/" icon={faFacebookSquare} />
                                <HorizontalSpacer />
                                Facebook
                            </li>
                            <li className="text-contact">
                                <IconBlock href="https://www.instagram.com/gianma_verbana_fisio/?hl=it" icon={faInstagramSquare} />
                                <HorizontalSpacer />
                                Instagram
                            </li>
                            <li className="text-contact">
                                <IconBlock href="https://www.linkedin.com/in/verbana-gianmarco-5590a6139/" icon={faLinkedin} />
                                <HorizontalSpacer />
                                LinkedIn
                            </li>
                        </ul>
                    </Col>
                    <Col lg='4' className="text-center mb-5">
                        <p className="text-primary" style={{fontSize: '18px'}}>
                        QI Fisio, Vimercate
                        </p>
                        <p className="mt-4" style={{fontSize: '16px', fontWeight: '600', fontColor: 'var(--logo_dark)'}}>
                        Via Rota 26<br/>20871 Vimercate (MB)<br/>Italia
                        </p>
                        <div id="map1" style={{width: '100%'}}>
                            <iframe frameBorder="0" title='Map Vimercate' style={{border: 0, width: '300px', height: '300px'}} src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDoKzcnJj2XfyqJi8RlwF10H35iuquvKwE&q=Qi+Fisio+Vimercate" allowFullScreen></iframe>
                        </div>
                    </Col>
                    <Col lg='4' className="text-center mb-5">
                        <p className="text-primary" style={{fontSize: '18px'}}>
                        Polimedica Brianza, Roncello
                        </p>
                        <p className="mt-4" style={{fontSize: '16px', fontWeight: 600, fontColor: 'var(--logo_dark)'}}>
                        Via Foscolo 4<br/>
                        20877 Roncello (MB)<br/>
                        Italia
                        </p>
                        <div id="map2">
                            <iframe frameBorder="0" title='Map Roncello' style={{border: 0, width: '300px', height: '300px'}} src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDoKzcnJj2XfyqJi8RlwF10H35iuquvKwE&q=Polimedica+Brianza+Roncello" allowFullScreen></iframe>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};


export default Contacts;
